import React from 'react';
import { NamedLink, ResponsiveImage } from '../../components';
import { createSlug } from '../../util/urlHelpers';
import css from './DealItemsMaybe.module.css';

const DealItemsMaybe = props => {
  const { dealItem } = props;

  const { images = [], attributes } = dealItem || {};
  const { title } = attributes || {};

  const firstImage = images && images?.length > 0 ? images[0] : null;

  const dealItemId = dealItem?.id?.uuid || '';
  const slug = createSlug(title);

  return (
    <div>
      <div className={css.dealItem}>
        <NamedLink name={'ListingPage'} params={{ slug, id: dealItemId }}>
          <ResponsiveImage
            image={firstImage}
            variants={['listing-card', 'listing-card-2x']}
            alt={'listing image'}
          />
          <h3>{title}</h3>
        </NamedLink>
      </div>
    </div>
  );
};

export default DealItemsMaybe;
